module.exports = __webpack_public_path__ + "static/media/img-dentist-quote.4da73c02.png";